import { isSameYear as isSameYear_ } from "date-fns";

import type { Time } from "../time";

export function isSameYear(first: Time, second: Time, ...rest: ReadonlyArray<Time>): boolean;
export function isSameYear(first: Time, ...rest: ReadonlyArray<Time>): boolean {
	return rest.every((time) => isSameYear_(first, time));
}
